module.exports = __webpack_public_path__ + "img/张岩峰.130b04cb.jpg";